<template>
    <div>
      <div class="container"> 	
        <!-- projects -->
        <div class="  wthree animate__animated  animate__backInLeft nimate__backInDown row"  style="width: 100%; ">     
          <h2 class="agileits-title w3title1">重点项目</h2>
          <!-- <p class="top-p animate__shakeY">重点在研项目，主要项目名称.</p> -->
          <div class="w3ls-title"> 
        </div>
            <div class="row col-md-12 agileits-w3layouts animate__animated  nimate__backInDown"  > 
              <div class="clearfix"> </div>
              <el-table
              stripe="true"
              :data="tableData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
            >
                <el-table-column prop="projectName" label="主要候选药品"  width="260" />
                <el-table-column prop="therapyArea" label="治疗领域"  width="260" />
                <el-table-column prop="studyPhase" label="研究阶段"  width="260" />
                <el-table-column prop="indication" label="适应症"  width="260" />
                <el-table-column prop="projectType" label="项目类型"  width="260" />
                <!-- <el-table-column prop="projectDescribe" label="项目描述"  width="260" /> -->
            </el-table>
            </div>
        <div class="clearfix"> </div>
          </div>	 
        </div>
    <!-- //projects --> 
  </div>
</template>
<style>
.el-scrollbar__view {
  display: unset !important;
}
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}
.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>
<script lang="ts" setup>
    import * as  http from '@/request/http'
    import { ref, onMounted } from 'vue'
    import { nextTick } from 'vue';
    import { reactive} from 'vue';

    interface PortalProjectMedicines {
      projectName: string
      therapyArea: string
      studyPhase: string
      indication: string
    }

    const tableRowClassName = ({
      row,
      rowIndex,
    }: {
      row: PortalProjectMedicines
      rowIndex: number
    }) => {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    }
    onMounted(async () => {
      try {
 
        handlePageChanged( {newPage:1})
      } catch (error) {
        console.error('Error loading data:', error);
      }
    });
    const  handlePageChanged=({
      newPage
     }: {
      newPage: 1
    })=> {
       let  param = {
          newTitle: '',
          currentPage: newPage
       }
        http.projectMedicines.projectMedicineslist(param).then(res=>{
           console.log(tableData)
           res.data.rows.forEach(item=>{
            tableData.push(item)
           })
        nextTick(); // 等待 DOM 更新完成
        })
    }
     const  tableData: PortalProjectMedicines[] = reactive([
    ])
</script>
